import mapboxglSupported from '@mapbox/mapbox-gl-supported';
import { sendEvent } from './analytics';
import safeLocalStorage from './safeLocalStorage';

const SUPPORT_MAP_KEY = 'mapbox-supported';

export const sendMapboxSupportedEvent = () => {
  const isSupported = mapboxglSupported.supported();
  const currentValue = isSupported ? '1' : '0';
  const storageValue = safeLocalStorage.getItem(SUPPORT_MAP_KEY);
  if (storageValue && storageValue === currentValue) return;
  sendEvent(window.eventCategory, 'map', isSupported ? 'supported' : 'not_supported');
  safeLocalStorage.setItem(SUPPORT_MAP_KEY, currentValue);
};
